import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'invalidControl',
  pure: false, // Care with this. This runs every change detection occurs.
})
export class InvalidControlPipe implements PipeTransform {
  transform(control: AbstractControl): boolean {
    const errors = Object.keys(control.errors || {});
    let touchedError = false;

    for (const error of errors) {
      if (control.errors[error] !== null) {
        touchedError = true;
        break;
      }
    }

    return control.invalid && ((control.touched && touchedError) || (control.dirty && (control.errors.maxlength !== null && control.errors.maxlength !== undefined)));
  }
}
